import { IdConstants } from '@/components/Forms/constants';

export const isCountryUkraine = (country: Nullable<string>): boolean => country === IdConstants.UKRAINE;
export const isRegionKyiv = (region: Nullable<string>): boolean => region === IdConstants.KYIV;
export const isRegionSevastopol = (region: Nullable<string>): boolean => region === IdConstants.SEVASTOPOL;
